import React from 'react';
import { Link } from 'react-router-dom';
import { List } from 'semantic-ui-react';


export const renderListItem = (logObj, key) => {
  const {timestamp, url, icon, event} = logObj;
  const updated = new Date(parseInt(timestamp, 10)).toLocaleDateString();

  return (
    <List.Item key={key}>
      <List.Icon name={icon} size='large' verticalAlign='middle' />
      <List.Content>
        <List.Header as={Link} to={`/${url}`}>{event}</List.Header>
        <List.Description >{`Last Update: ${updated}`}</List.Description>
      </List.Content>
    </List.Item>
  )
}



// WEBPACK FOOTER //
// ./src/helper/notification-helper.js